// src/components/report_details/EmployeeDetails.tsx
import React from 'react';
import { Linkedin, Twitter, Github } from 'lucide-react';
import EmployeeHistory from './EmployeeHistory';
import { useTranslation } from 'react-i18next';
import { EmployeeDetail } from '../../../types/interfaces';

interface EmployeeDetailsProps {
  employee: EmployeeDetail;
  onBack: () => void;
}

const EmployeeDetails: React.FC<EmployeeDetailsProps> = ({ employee, onBack }) => {
  const fallbackPhoto = 'https://profile-pics.damelio.io/user-default.jpg';

  const getPhoto = () => {
    const url = employee.photo_url?.trim();
    return url && url.length > 0 ? url : fallbackPhoto;
  };
  const { t } = useTranslation();

  return (
    <div className="p-8">
      <button
        onClick={onBack}
        className="bg-gray-800 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors duration-300 flex items-center mb-4 transform hover:scale-105 hover:shadow-lg"
      >
        ← {t('myResearch.back')}
      </button>

      <div className="flex flex-col items-center bg-white p-6 rounded-lg shadow-lg" style={{ boxShadow: '0px 4px 10px rgba(169, 169, 169, 0.6)' }}>
        <img
          src={getPhoto()}
          alt={employee.name}
          onError={(e) => {
            e.currentTarget.onerror = null; // Evita loop infinito
            e.currentTarget.src = fallbackPhoto;
          }}
          className="w-32 h-32 rounded-full object-cover mb-4"
        />
        <h2 className="text-2xl font-bold">{employee.name}</h2>
        {employee.title && <p className="text-gray-600 text-lg">{employee.title}</p>}
        {employee.headline && employee.headline !== employee.title && (
          <p className="text-gray-600 text-lg">{employee.headline}</p>
        )}
        {employee.email && employee.email !== "email_not_unlocked@domain.com" && (
          <p className="text-gray-600">{employee.email}</p>
        )}
        <div className="mt-4 flex space-x-4">
          {employee.linkedin_url && (
            <a href={employee.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700">
              <Linkedin className="w-6 h-6" />
            </a>
          )}
          {employee.twitter_url && (
            <a href={employee.twitter_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700">
              <Twitter className="w-6 h-6" />
            </a>
          )}
          {employee.github_url && (
            <a href={employee.github_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700">
              <Github className="w-6 h-6" />
            </a>
          )}
        </div>
        {(employee.city || employee.state || employee.country) && (
          <div className="mt-4 text-gray-600">
            <p>
              {employee.city ? employee.city : ''}
              {employee.city && employee.state ? ', ' : ''}
              {employee.state ? employee.state : ''}
              {(employee.city || employee.state) && employee.country ? ', ' : ''}
              {employee.country}
            </p>
          </div>
        )}
      </div>

      {/* Historial laboral */}
      <EmployeeHistory jobHistory={employee.job_history || []} />
    </div>
  );
};

export default EmployeeDetails;
